/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable, of, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { setting } from '../../../../../setting';
import { map, takeUntil } from 'rxjs/operators';

@Injectable()
export class AddressesService {

  private endpoint: string;
  private endpointLocationsAll = '';
  private urlDev = setting.apiBookingUrl;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(private http: HttpClient) {
     this.endpoint = this.urlDev + 'getLocationTransfer';
     this.endpointLocationsAll = `${this.urlDev}search-locations/`;
  }

  getLocationsAll(keyword: string, country?: any, pointToPoint?: boolean, category?: string): Observable<any[]> {
    if (keyword && keyword.length > 2) {
      let url = '';

      if(country && category === 'TRANSFERS') {
        if(pointToPoint) {
          url = `${this.endpointLocationsAll}${keyword}?country=${country}&address=true`;
        } else {
          url = `${this.endpointLocationsAll}${keyword}?country=${country}`;

        }
      } else {

        // if(pointToPoint) {
        //   url = `${this.endpointLocationsAll}${keyword}?address=true`;
        // } else {
          if(category === 'RENTCAR' || category === 'CRUISES') {
              url = `${this.endpointLocationsAll}${keyword}?category=${category}&limit=15`; // ver el limit por categoría;
          } else {

            if(category === 'TRANSFERS' && pointToPoint) {
              url = `${this.endpointLocationsAll}${keyword}?category=${category}&address=true`;
            } else {
              url = `${this.endpointLocationsAll}${keyword}?category=${category}`;
            }
          }

        // }
      }

      return this.http.get<any>(url).pipe(
        takeUntil(this._unsubscribeAll),
        map((res: any) => {

          const mergedArray = [
            {
              airports: res.airports,
              type: 'airport',
            },
            {
                cities: category === 'TRANSFERS' ? res.addressGoogle : res.cities,
                type: 'city',
            },
            {
                hotels: res.hotels,
                type: 'hotel',
            },
            {
              ports: res.ports,
              type: 'port',
            },
            {
                trains: res.trains,
                type: 'train',
            },
            {
                buses: res.buses,
                type: 'bus',
            },
            {
              restaurants: res.restaurants,
              type: 'restaurant',
            },
            {
                attractions: res.attractions,
                type: 'attraction',
            }

          ];
          return mergedArray;
        })
      );
    } else {
      return of([]); // Retorna un array vacío si no hay keyword
    }
  }



  _getAddress(iataCode: any, keyword: any, categoryId: any, type: any): Observable<any[]> {
    if (keyword) {
      const url = this.endpoint + '/' + keyword + '/' + categoryId + '/' + iataCode;
      return this.http.get(url)
      .map((res: any) => {
        const json = res.data;
          if (type) {
            const resu = json.filter(d => d.type !== type);
            return resu;
          } else {
            return json;
         }
        });
    } else {
      return Observable.of([]);
    }
  }


}
